import { render, staticRenderFns } from "./BaseCheckRecordsTable.vue?vue&type=template&id=4cba52af"
import script from "./BaseCheckRecordsTable.vue?vue&type=script&lang=js"
export * from "./BaseCheckRecordsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports